import { cropConfigV2Schema } from "@redotech/redo-model/crop-config-v2";
import * as z from "zod";

export const cropImage = {
  name: "cropImage" as const,
  input: z.object({ imageUrl: z.string(), cropConfig: cropConfigV2Schema }),
  output: z.object({ imageUrl: z.string() }),
};
